<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.mac_id" placeholder="设备物理地址"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getDevices">查询</el-button>
				</el-form-item>
				<span class="precision">精确度</span>
				<el-select @change="selectchange" v-model="selectValue" placeholder="请选择">
				    <el-option
				      v-for="item in options"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				</el-select>
				<!--<el-form-item>
					<el-button type="primary" @click="handleAdd">导出</el-button>
				</el-form-item>-->
			</el-form>
		</el-col>

		<!--列表-->
		<el-table @sort-change='sortion' :data="users" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<!--<el-table-column type="selection" width="50">
			</el-table-column>-->
			<el-table-column type="index" width="40">
			</el-table-column>
			<el-table-column prop="mac_id" label="设备物理地址" width="150" >
			</el-table-column>
			<el-table-column prop="province" label="定位省份"  >
			</el-table-column>
			<el-table-column prop="city" label="定位城市"  >
			</el-table-column>
			<el-table-column prop='district' label="定位区域"   >
			</el-table-column>
			<el-table-column prop="updata_time" label="设备定位时间" min-width='160' sortable='custom'>
			</el-table-column>
			<el-table-column prop="assign_province" label="分配省份"  >
			</el-table-column>
			<el-table-column prop="assign_city" label="分配城市"  >
			</el-table-column>
			<el-table-column prop='assign_district' label="分配区域"   >
			</el-table-column>
			<el-table-column prop="setTime" label="设备分配时间" min-width='160'  sortable='custom'>
			</el-table-column>
			<el-table-column prop="upper_sysno" width='76' v-if='GLOBAL.organ_sysno==GLOBAL.adminSysno.adminOrgan' label="机构编号"  >
			</el-table-column>
			<!--<el-table-column label="操作" width="100">
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
				</template>
			</el-table-column>-->
			<!--<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>-->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除{{addFormVisible}}</el-button>-->
			<el-pagination layout="prev, pager, next,jumper"  @current-change="handleCurrentChange"  :page-size="size" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</section>
</template>

<script>
	import util from '../common/js/util'
	//import NProgress from 'nprogress'
	import { getDeviceArea} from '../api/api';

	export default {
		data() {
			return {
				filters: {
					mac_id: ''
				},
				sort:'desc',
				prop:'updata_time',
				users: [],
				total: 0,
				page: 1,
				size:10,
				listLoading: false,
				sels: [],//列表选中列
				dialogFormVisible: false,
				form: {
			        name: '',
			        region: '',
			        date1: '',
			        date2: '',
			        delivery: false,
			        type: [],
			        resource: '',
			        desc: ''
		     	},
				addLoading: false,
				runningTime:[],//设备列表运行时间
				options: [{
		          value: 'province',
		          label: '省份'
		        }, {
		          value: 'city',
		          label: '城市'
		        }, {
		          value: 'district',
		          label: '区县'
		        }],
		        selectValue: '省份',
		        precision:'province',
			}
		},
		methods: {
			selectchange(value){
				console.log(value)
				this.precision=value
			},
			//排序
			sortion(row){
				this.prop=row.prop
				switch(row.order){
					case 'descending':
						this.sort='desc'
					break;
					case 'ascending':
						this.sort='asc'
					break;
				}
				this.getDevices()
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.page = val;
				this.getDevices();
			},
			//获取设备列表
			getDevices() {
				var that=this
				console.log(that.GLOBAL)
				let para = {
					mac_id:this.filters.mac_id.trim(),
					organ_sysno:that.GLOBAL.organ_sysno,
					precision:this.precision,
					prop:this.prop,
					sort:this.sort,
					pageNo:this.page,
					pageSize:this.size,
				};
				console.log(para)
				this.listLoading = true;
				//NProgress.start();
				getDeviceArea(para).then((res) => {
					console.log(res)
					this.total = res.data.data.rowcount;
					this.users = res.data.data.list;
					this.listLoading = false;
					//NProgress.done();
				});
			},
			//删除
			handleDel: function (index, row) {},
			//显示编辑界面
			handleEdit: function (index, row) {},
			//显示新增界面
			handleAdd: function () {},
			//编辑
			editSubmit: function () {},
			
			selsChange: function (sels) {
				this.sels = sels;
			},
			
		},
		mounted() {
			this.getDevices();
		}
	}

</script>

<style lang="scss" slot-scope>
	.precision{
		margin-left: 10%;
		font-size: 14px;
		color: #606266;
	}
</style>


// WEBPACK FOOTER //
// src/components/device_area.vue